var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"results-table__cell",attrs:{"title":_vm.docData[_vm.cellData.dataFields[0]]}},[_vm._v("\n  "+_vm._s(_vm.docData[_vm.cellData.dataFields[0]])+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }